import React from 'react';
import { Typography, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { TemplateSection } from '../../_types';
import { filterActiveSections } from '../../_utils/templateFilters';
import { translate as t } from 'hooks/useTranslations';

interface SectionNavigationProps {
  sections: TemplateSection[];
  selectedSectionId: number | null;
  onSectionSelect: (sectionId: number) => void;
}

const SectionNavigation: React.FC<SectionNavigationProps> = ({
  sections,
  selectedSectionId,
  onSectionSelect,
}) => {
  const activeSections = filterActiveSections(sections);

  return (
    <List
      sx={{
        flex: 1,
        overflow: 'auto',
        p: 0,
      }}
    >
        {activeSections.map((section) => {
          const isSelected = selectedSectionId === section.id;
          const isRequired = section.effectiveIsRequired;

          return (
            <ListItem
              key={section.id}
              disablePadding
            >
              <ListItemButton
                selected={isSelected}
                onClick={() => onSectionSelect(section.id)}
                sx={{
                  px: 3,
                  py: 3,
                  '&.Mui-selected': {
                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                    borderLeft: '3px solid',
                    borderLeftColor: 'primary.main',
                    '&:hover': {
                      backgroundColor: 'rgba(25, 118, 210, 0.12)',
                    },
                  },
                }}
              >
                <ListItemText
                  primary={
                    <Typography
                      variant='subtitle2'
                      sx={{
                        fontWeight: isSelected ? 600 : 500,
                        mb: 0.5,
                        color: isSelected ? 'primary.main' : 'text.primary',
                      }}
                    >
                      {section.effectiveName || section.name || 'Unnamed Section'}
                    </Typography>
                  }
                  secondary={
                    <Typography
                      variant='caption'
                      sx={{
                        color: isSelected ? 'primary.main' : 'text.secondary',
                        opacity: isSelected ? 0.8 : 1,
                      }}
                    >
                      {isRequired
                        ? t('performanceReporting.templates.viewer.required')
                        : t('performanceReporting.templates.viewer.optional')}
                    </Typography>
                  }
                />
              </ListItemButton>
            </ListItem>
          );
        })}
    </List>
  );
};

export default SectionNavigation;
